<template>
  <div
    class="input-field"
    :class="{ 'error': validationErrors?.length }"
  >
    <label v-if="label">
      {{ label }}
    </label>

    <div class="flex">
      <input
        v-model="model"
        :required="required"
        maxlength="255"
        :type="showPassword ? 'password' : 'text'"
      >

      <div
        class="border border-l-0 border-chrome-medium hover:cursor-pointer z-[1] hover:border-l hover:ring-1 hover:ring-chrome-medium"
        :title="showPassword ? 'Show' : 'Hide'"
        @click="showPassword = !showPassword"
      >
        <div class="h-full flex items-center justify-center px-1">
          <FontAwesomeIcon
            :icon="showPassword ? faEye : faEyeSlash"
            class="text-chrome-dark w-8"
          />
        </div>
      </div>
    </div>

    <span
      v-for="(error, index) in validationErrors"
      :key="index"
      class="validation-error-message fs-9 block"
    >
      {{ error }}
    </span>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const model = defineModel({ type: String, default: '' });

const showPassword = ref(true);

defineProps({
  validationErrors: {
    type: Array,
    default: () => [],
  },
  required: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: null,
  },
});
</script>
